import apolloClient from "../apollo";
import getCustomerForgotPasswordLinkMutation from "../graphql/mutations/getCustomerForgotPasswordLink";
import passwordResetMutation from "../graphql/mutations/setCustomerPasswordByPasswordResetID";
import getCurrentCustomerQuery, {
	readCurrentCustomer,
} from "../graphql/queries/getCurrentCustomer";
import getPasswordResetIdStatusQuery, {
	readPasswordResetIdStatus,
} from "../graphql/queries/getCustomerPasswordResetIdStatus";
import changeCustomerPassword from "../graphql/mutations/changeCustomerPassword";
import changeCustomerEmail from "../graphql/mutations/changeCustomerEmail";
import addAlternateAdminMutation from "../graphql/mutations/addAlternateAdmin";
import removeAlternateAdminMutation from "../graphql/mutations/removeAlternateAdmin";
import CustomerAlreadyExistsException from "../utils/exceptions/customer/AlreadyExistsException";
import CustomerNotFoundException from "../utils/exceptions/customer/NotFoundException";
import { getExceptionFields } from "../apollo/operation-errors";

const catchCustomerServiceExceptions = apolloError => {
	const error = apolloError.graphQLErrors[0];
	if (error && error.code === 406) {
		throw new CustomerAlreadyExistsException(...getExceptionFields(error));
	}

	if (error && error.code === 404) {
		throw new CustomerNotFoundException(...getExceptionFields(error));
	}

	throw apolloError;
};

export const getPasswordResetIdStatus = context => {
	const passwordResetID = context.query.key;
	return apolloClient(context)
		.query({
			query: getPasswordResetIdStatusQuery,
			variables: { passwordResetID },
		})
		.then(readPasswordResetIdStatus)
		.catch(catchCustomerServiceExceptions);
};

export const getCustomerForgotPasswordLink = ({ email }) =>
	apolloClient()
		.mutate({ mutation: getCustomerForgotPasswordLinkMutation, variables: { email } })
		.then(() => true)
		.catch(catchCustomerServiceExceptions);

export const resetPassword = ({ passwordResetID, password }) =>
	apolloClient()
		.mutate({ mutation: passwordResetMutation, variables: { passwordResetID, password } })
		.then(() => true)
		.catch(catchCustomerServiceExceptions);

export const changePassword = ({ currentPassword, newPassword }) =>
	apolloClient()
		.mutate({
			mutation: changeCustomerPassword,
			variables: { oldPassword: currentPassword, newPassword },
		})
		.then(() => true)
		.catch(catchCustomerServiceExceptions);

export const changeEmail = ({ email, password }) =>
	apolloClient()
		.mutate({
			mutation: changeCustomerEmail,
			variables: { newEmail: email, password },
		})
		.then(() => true)
		.catch(catchCustomerServiceExceptions);

export const getCurrentCustomer = ({ req, res }) =>
	apolloClient({ req, res })
		.query({ query: getCurrentCustomerQuery })
		.then(readCurrentCustomer)
		.catch(catchCustomerServiceExceptions);

export const addAlternateAdmin = ({ subscriptionID, email }) =>
	apolloClient()
		.mutate({
			mutation: addAlternateAdminMutation,
			variables: { subscriptionID, email },
		})
		.then(() => email)
		.catch(catchCustomerServiceExceptions);

export const removeAlternateAdmin = (subscriptionID, email) =>
	apolloClient()
		.mutate({
			mutation: removeAlternateAdminMutation,
			variables: { subscriptionID, email },
		})
		.then(() => true)
		.catch(catchCustomerServiceExceptions);
